import { NotifyHelper } from "../../../helpers/toast"
import { ePageBaseStatus } from "../../../models/ePageBaseStatus"
import { eDiemDanhTrangThaiActionTypeIds, IDiemDanhTrangThaiActionTypes } from "../../action-types/danh-muc/IDiemDanhTrangThaiActionTypes"
import { IDiemDanhTrangThaiPageState } from "../../page-state-model/danh-muc/IDiemDanhTrangThaiPageState"

const initialState: IDiemDanhTrangThaiPageState = {
    status: ePageBaseStatus.is_not_initialization,
    nt_diem_danh_trang_thais: [],
    nt_diem_danh_trang_thai_selected_ids: [],
    nt_diem_danh_trang_thai_editing: undefined,
    is_show_delete_confirm: false,
    is_show_detail_modal: false
}

export const trangThaiReducer = (state: IDiemDanhTrangThaiPageState = initialState, action: IDiemDanhTrangThaiActionTypes): IDiemDanhTrangThaiPageState => {
    switch (action.type) {
        case eDiemDanhTrangThaiActionTypeIds.LOAD_START:
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case eDiemDanhTrangThaiActionTypeIds.LOAD_SUCCESS:
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nt_diem_danh_trang_thais: action.payload
            }
        case eDiemDanhTrangThaiActionTypeIds.LOAD_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                nt_diem_danh_trang_thais: []
            }
        case eDiemDanhTrangThaiActionTypeIds.SHOW_DETAIL:
            return {
                ...state,
                is_show_detail_modal: true,
                nt_diem_danh_trang_thai_editing: action.payload
            }
        case eDiemDanhTrangThaiActionTypeIds.CLOSE_DETAIL:
            return {
                ...state,
                is_show_detail_modal: false,
                nt_diem_danh_trang_thai_editing: undefined
            }
        case eDiemDanhTrangThaiActionTypeIds.CHANGE_SELECTED_IDS:
            return {
                ...state,
                nt_diem_danh_trang_thai_selected_ids: action.payload
            }
        case eDiemDanhTrangThaiActionTypeIds.SHOW_CONFIRM:
            return {
                ...state,
                is_show_delete_confirm: true
            }
        case eDiemDanhTrangThaiActionTypeIds.CLOSE_CONFIRM:
            return {
                ...state,
                is_show_delete_confirm: false
            }

        case eDiemDanhTrangThaiActionTypeIds.DELETE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case eDiemDanhTrangThaiActionTypeIds.DELETE_SUCCESS:
            NotifyHelper.Success("Xoá dữ liệu thành công.")
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_delete_confirm: false
            }
        case eDiemDanhTrangThaiActionTypeIds.DELETE_ERROR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_delete_confirm: false
            }


        case eDiemDanhTrangThaiActionTypeIds.SAVE_START:
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case eDiemDanhTrangThaiActionTypeIds.SAVE_SUCCESS:
            NotifyHelper.Success("Thay đổi dữ liệu thành công.")
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_detail_modal: false
            }
        case eDiemDanhTrangThaiActionTypeIds.SAVE_ERR:
            NotifyHelper.Error(action.payload)
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                is_show_detail_modal: false
            }

        default:
            return state;
    }

}